// extracted by mini-css-extract-plugin
export default {"drawing_button":"Drawing_drawing_button__Eadi3","uploaderContainer":"Drawing_uploaderContainer__wE7sn"};